import { ListItemProps } from '@silverfort/sf-components/dist/ListItem';

export const StaleSettingsOptions: Array<ListItemProps<number>> = [
    { title: '7 days', value: 7 },
    { title: '14 days', value: 14 },
    { title: '30 days', value: 30 },
    { title: '90 days', value: 90 },
    { title: '180 days', value: 180 }
];

export const DEFAULT_STALE_SETTING = StaleSettingsOptions[3].value;

export const StaleStatusOptions: Array<ListItemProps<boolean>> = [
    { title: 'Active', value: false },
    { title: 'Stale', value: true }
];
